export default "#version 300 es\n\nin vec2 position;\n\nvoid main() {\n  gl_Position = vec4(position, 0, 1);\n}\n"